export const roles = [
  { label: "Avvocato", value: "AVV" },
  { label: "Consulente Tecnico D'Ufficio", value: "CTU" },
  { label: "Parte", value: "PARTE" },
  { label: "Notaio/Ufficiale", value: "NOT" },
  { label: "Curatore/Tutore/Amministratore di Sostegno", value: "TUT" },
  { label: "Ausiliare Incaricato", value: "AUS" },
  { label: "Custode", value: "CUS" },
  { label: "Delegato", value: "DEL" },
  { label: "Creditore del Comitato Creditori", value: "CCC" },
  { label: "Organismo di Composizione della Crisi", value: "OCC" }
];
